<template>
  <ul class="nav justify-content-center col-12">
    <li class="nav-item">
      <router-link @click="$emit('clickmenu')" :class="{ active: isActive, 'text-danger': hasError }"
        class="nav-link mx-2 px-3 py-2" to="/">Home</router-link>
    </li>
    <li class="nav-item">
      <router-link @click="$emit('clickmenu')" class="nav-link mx-2 px-3 py-2" to="/quem-somos">Quem Somos</router-link>
    </li>
    <li class="nav-item">
      <router-link @click="$emit('clickmenu')" class="nav-link mx-2 px-3 py-2" to="/cursos">Cursos</router-link>
    </li>
    <template v-if="qtd_categorias > 0">
      <li class="nav-item dropdown">
        <a class="nav-link mx-2 px-3 dropdown-toggle py-2" data-bs-toggle="dropdown" aria-expanded="false">Notícias</a>
        <Transition>
          <ul class="dropdown-menu dropdown-menu-end px-3">
            <span class="titulo_sub_sub">Categorias</span>
            <li class="px-2 pt-2"><router-link @click="$emit('clickmenu')" class="dropdown-item"
                to="/noticias">Todas</router-link></li>
            <li class="px-2 pt-2" v-for="cat in lista_categorias_noticias" :key="cat.valor">
              <router-link @click="$emit('clickmenu')" class="dropdown-item"
                :to="'/noticias/cat/' + cat.texto + '/1'">{{
                  cat.texto }}</router-link>
            </li>
          </ul>
        </Transition>
      </li>
    </template>
    <template v-else>
      <li class="nav-item">
        <router-link @click="$emit('clickmenu')" class="nav-link mx-2 px-3 py-2" to="/noticias">Notícias</router-link>
      </li>
    </template>
    <li class="nav-item">
      <router-link @click="$emit('clickmenu')" class="nav-link mx-2 px-3 py-2" to="/contato">Contato</router-link>
    </li>
    <li class="nav-item dropdown">
      <template v-if="auth.estaLogado()">
        <a class="nav-link dropdown-toggle" style="margin-top: -10px; text-transform: none;" role="button"
          data-bs-toggle="dropdown" aria-expanded="false"> {{ auth.nomeUser }}
        </a>
        <ul class="dropdown-menu dropdown-menu-end px-3">
          <li class="px-2 pb-3">
            <div class="">
              <small style="font-size: 10px;">Usuário ({{ auth.acessoUser }})</small> <br>
              <router-link @click="$emit('clickmenu')" class="dropdown-item" to="/meusdados"><i class="bi bi-gear"></i>
                Meus dados</router-link>
              <router-link @click="$emit('clickmenu')" class="dropdown-item" v-if="auth.type_access <= 4 && false"
                to="/meuspagamentos"><i class="bi bi-coin"></i> Minhas Contribuições</router-link>
            </div>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <template v-if="auth.type_access == 0">
            <li class="text-center titulo_sub">Master</li>
            <li>
              <hr class="dropdown-divider">
            </li>
            
            <li>
              <hr class="dropdown-divider">
            </li>
          </template>
          <template v-if="['1', '2'].includes(auth.type_access)">
            <li class="text-center titulo_sub">Administrador</li>
            <li>
              <router-link @click="$emit('clickmenu')" class="dropdown-item" to="/admin/conf_gerais"><i
                  class="bi bi-gear"></i>
                Configurações gerais</router-link>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li class="pb-2 border-bottom"><span class="titulo_sub_sub"><i class="bi bi-newspaper"></i> Noticias</span>
              <ul>
                <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                    to="/admin/cad_noticia">Cadastro</router-link></li>
                <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                    to="/admin/cad_categoria_noticia">Categorias</router-link></li>
              </ul>
            </li>
            <li class="pb-2 border-bottom"><router-link @click="$emit('clickmenu')" class="dropdown-item" to="/admin/cad_cursos">
              <i class="bi bi-backpack2"></i>
              Cadastro de Cursos
            </router-link></li>
            <li><router-link @click="$emit('clickmenu')" class="dropdown-item" to="/admin/parceiros">
              <i class="bi bi-people-fill"></i>
              Cadastrar Parceiro
            </router-link></li>
            <template v-if="false">
            <li>
              <hr class="dropdown-divider">
            </li>
            <li class="pb-2 border-bottom"><span class="titulo_sub_sub"><i class="bi bi-bank"></i> Financeiro</span>
              <ul>
                <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                    to="/admin/cad_financas_receitas">Receitas</router-link></li>
                <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                    to="/admin/cad_financas_despesas">Despesas</router-link></li>
                <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                    to="/admin/cad_financas_categoria_despesa">Categorias de despesas</router-link></li>
                <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                    to="/admin/cad_financas_forma_pagamento">Formas de pagamento</router-link></li>
              </ul>
            </li>
            </template>
            <li><router-link @click="$emit('clickmenu')" class="dropdown-item" to="/admin/lista_usuarios">Usuários
                Cadastrados</router-link></li>
            <li>
              <hr class="dropdown-divider">
            </li>
          </template>
          <template v-if="['1', '2', '3', '4', '5'].includes(auth.type_access)">
            <li class="text-center titulo_sub">Eleitor Multiplicador</li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><router-link @click="$emit('clickmenu')" class="dropdown-item" to="/mult/indicacoes">Minhas
                indicações </router-link></li>
            <template
              v-if="(['1'].includes(auth.type_access) || (['3', '4'].includes(auth.type_access) && auth.dataValidade())) && false">
              <li>
                <hr class="dropdown-divider">
              </li>
              <li class="text-center titulo_sub">Eleitor +</li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><router-link @click="$emit('clickmenu')" class="dropdown-item" to="/admin/financeiro">Relatório de
                  Finanças</router-link></li>
            </template>
            <li>
              <hr class="dropdown-divider">
            </li>
          </template>

          <template v-if="['4', '5', '6'].includes(auth.type_access)">
            <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                :to="'/upgrade/' + (auth.type_access - 1)">
                Tornar-se um Eleitor {{ (auth.type_access == 6 ? 'Multiplicador' : (auth.type_access == 5 ? '+' :
                  'Lider')) }}
              </router-link></li>
            <!-- <li class="text-center titulo_sub">Eleitor Lider</li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><router-link @click="$emit('clickmenu')" class="dropdown-item"
                  to="/admin/lideranca">Liderança</router-link></li> -->
          </template>
          <li class="text-end p-2">
            <button class="btn btn-danger btn-sm" @click="sair()">Sair</button>
          </li>
        </ul>
      </template>
      <template v-else>
        <router-link @click="$emit('clickmenu')" class="nav-link mx-2 px-3 py-2" to="/login">
          Área de membro
        </router-link>
      </template>
    </li>
  </ul>
</template>

<script>
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth.js'

export default {
  name: "Menu",
  components: { api },
  data() {
    return {
      auth: AuthStore(),
      lista_categorias_noticias: null,
      qtd_categorias: 0,
    }
  },
  methods: {
    sair() {
      this.auth.clear();
      this.$router.push('/');
    },
    async cat_noticias() {
      this.lista_categorias_noticias = await api.post("news_category/list_select_m");
      this.qtd_categorias = this.lista_categorias_noticias.length;
    },
  },
  mounted() {
    this.cat_noticias();
  },
};
</script>

<style scoped>
@media (max-width: 999px) {
  .nav-item {
    margin-right: 40px;
    display: block;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid var(--cor-base-texto);
  }
}

@media (min-width: 1000px) {
  .nav-item::before {
    content: "|";
    padding-right: 40px;
    color: #000;
    position: relative;
    display: inline;
  }

  .nav-item {
    margin-right: 40px;
    display: block;
  }

}


.nav-item:first-child::before {
  content: "";
}

.dropdown:hover>.dropdown-menu {
  display: block;
}

/* ul, li {
  border: 1px solid green;
} */

li {
  list-style: none;
}

.nav-link {
  color: #000;
  /* border-bottom: 2px solid transparent; */
  text-transform: uppercase;
  transition: 0.5s;
  font-weight: bold;
  padding-left: 30px;
  display: contents;
  cursor: pointer;
  /* padding-right: 30px; */
  /* border-right: 2px solid #000; */
  /* font-weight: bold; */
}

.nav-link:hover,
.router-link-active {
  color: var(--cor-base-texto) !important;
  border-bottom: 2px solid #fa6d13;
  transition: ease 500ms;
}

.titulo_sub {
  font-weight: bold;
  color: #777;
  font-size: 12px;
  text-transform: uppercase;
}

.titulo_sub_sub {
  font-weight: bold;
  color: var(--cor-base-texto);
  font-size: 12px;
}

.dropdown-menu {
  background-color: white !important;
  z-index: 3 !important;
}
</style>